const API_BASE = process.env.REACT_APP_API_BASE || '';

/** 买家端地址，用于从后台跳转店铺页等 */
export const WEB_BASE = process.env.REACT_APP_WEB_BASE || '';

/**
 * 统一请求封装：自动带 token，后端统一返回 { code, msg, data }
 */
export async function post(path, body) {
  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.token = token;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body || {}),
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  return res.json();
}

/**
 * 文件地址：字段值可能是 file id、历史 pathname 或外部 URL。
 * size 传缩略图长边像素 480/720/1080，不传默认 480
 */
export function fileUrl(value, size) {
  if (!value) {
    return '';
  }
  if (/^https?:\/\//i.test(value)) {
    return value;
  }
  const suffix = size ? `?size=${size}` : '';
  if (/^[0-9a-f]{32}$/i.test(value)) {
    return `${API_BASE}/file/${value}${suffix}`;
  }
  // 历史数据仍保存 pathname，走已废弃的旧接口兜底
  return `${API_BASE}/store/file/download/${value}${suffix}`;
}
